import { render } from "./tender.vue?vue&type=template&id=c28fc88c"
import script from "./tender.vue?vue&type=script&lang=js"
export * from "./tender.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/sale/tender/create/tender.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c28fc88c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c28fc88c', __exports__)) {
    console.log('reload')
    api.reload('c28fc88c', __exports__)
  }
  
  module.hot.accept("./tender.vue?vue&type=template&id=c28fc88c", () => {
    console.log('re-render')
    api.rerender('c28fc88c', render)
  })

}


export default __exports__